module.exports = __webpack_public_path__ + "img/mortgages-providers1.404a7d9.webp";